import TenwaysGiveawayPremiumModal from './modals/tenways-giveaway-premium-modal.jsx'
import TenwaysGiveawayAppModal from './modals/tenways-giveaway-app-modal.jsx'
import Spring24PremiumModal from './modals/spring24-premium-modal.jsx'

/**
 * @typedef {Object} PromotionConfig
 * @property {import("react").ReactComponent} Modal The modal component to show
 * @property {(isLoggedIn: boolean, isPremium: boolean) => boolean} isUserTarget Defines the audience
 * @property {string} start Promotion start datetime
 * @property {string} end Promotion end datetime
 */

/**
 * @type {PromotionConfig[]}
 */
export default [
    {
        Modal: Spring24PremiumModal,
        isUserTarget: (isLoggedIn, isPremium) => !isPremium,
        start: '2024-04-19',
        end: '2024-04-27 23:55',
    },
    {
        Modal: TenwaysGiveawayAppModal,
        isUserTarget: (isLoggedIn, isPremium) => isPremium,
        start: '2024-03-16',
        end: '2024-03-31 23:55',
    },
    {
        Modal: TenwaysGiveawayPremiumModal,
        isUserTarget: (isLoggedIn, isPremium) => !isPremium,
        start: '2024-03-16',
        end: '2024-03-31 23:55',
    },
]
